import dynamic from 'next/dynamic';
import type { FC, SyntheticEvent } from 'react';
import type { ReactDatePickerProps } from 'react-datepicker';

import { Loader } from '@/components/profile/LoaderWrapper';
import { Skeleton } from '@/components/Skeleton';

import { ScCustomHeader, ScDatePickerItem } from './styled';

import 'react-datepicker/dist/react-datepicker.css';
import { IconComponent } from '@/components/IconComponent';

const DatePicker = dynamic(
  () => import('react-datepicker').then((mod) => mod.default),
  {
    ssr: false,
    loading: () => (
      <Skeleton.Container padding="36px">
        <Loader size={60} />
      </Skeleton.Container>
    ),
  }
);

export interface DatePickerItemProps {
  startDate: Date | null;
  endDate: Date | null;
  secondary?: boolean;
  onChange(
    date: [Date | null, Date | null],
    event: SyntheticEvent<any, Event> | undefined
  ): void;
  onClickOutside?: () => void;
}

export const DatePickerItem: FC<DatePickerItemProps> = ({
  startDate,
  endDate,
  secondary,
  onChange,
  onClickOutside,
}) => {
  const renderCustomHeader: ReactDatePickerProps['renderCustomHeader'] = ({
    date,
    decreaseMonth,
    increaseMonth,
  }) => {
    const formattedDate = new Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric',
    }).format(date);

    return (
      <ScCustomHeader>
        <div className="arrow" onClick={decreaseMonth}>
          <IconComponent name="whiteArrowRight" size="20px" />
        </div>
        <span>{formattedDate}</span>
        <div className="arrow" onClick={increaseMonth}>
          <IconComponent name="whiteArrowRight" size="20px" />
        </div>
      </ScCustomHeader>
    );
  };

  return (
    <ScDatePickerItem secondary={secondary}>
      <div className="data-picker-wrapper">
        <DatePicker
          endDate={endDate}
          formatWeekDay={(nameOfDay) => nameOfDay.substring(0, 1)}
          inline
          onChange={onChange}
          onClickOutside={onClickOutside}
          renderCustomHeader={renderCustomHeader}
          selectsRange
          startDate={startDate}
        />
      </div>
    </ScDatePickerItem>
  );
};
